import { LINK_IDS, getLinkText } from '../nav-links';

export default {
  Developer: [
    getLinkText(LINK_IDS.DEVELOPER_MODE),
    getLinkText(LINK_IDS.EXTENSIONS),
    getLinkText(LINK_IDS.ADD_ON_SETTINGS),
    getLinkText(LINK_IDS.API_ACCESS)
  ],
  Account: [
    getLinkText(LINK_IDS.MY_PROFILE),
    getLinkText(LINK_IDS.ACCOUNT_SETTINGS_ADMIN),
    getLinkText(LINK_IDS.ACCOUNT_SETTINGS_OWNER),
    getLinkText(LINK_IDS.ACCOUNT_SUBSCRIPTIONS),
  ]
};
